import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InquiryAppointmentComponent } from './inquiry-appointment.component';
import { SharedModule } from '../../shared/shared.module';
import { BdcSharedModule } from '../shared/bdc-shared.module';
import { ConfirmInfoComponent } from './confirm-info/confirm-info.component';
import { InquiryAppointmentRoutingModule } from './inquiry-appointment-routing.module';
import { InquiryVehicleComponent } from './inquiry-vehicle/inquiry-vehicle.component';



@NgModule({
  declarations: [
    InquiryAppointmentComponent,
    ConfirmInfoComponent,
    InquiryVehicleComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BdcSharedModule,
    InquiryAppointmentRoutingModule
  ]
})
export class InquiryAppointmentModule { }
